/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is a donut chart different from a pie chart?`)
};

const es_donut_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué se diferencia un gráfico de dona de uno circular?`)
};

const de_donut_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie unterscheidet sich ein Donut-Diagramm von einem Kreisdiagramm?`)
};

const nl_donut_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe verschilt een donutdiagram van een cirkeldiagram?`)
};

const fr_donut_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En quoi un diagramme en anneau diffère-t-il d'un diagramme circulaire ?`)
};

const it_donut_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In cosa differisce un grafico a ciambella da un grafico a torta?`)
};

const pt_br2_donut_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a diferença entre um gráfico de rosca e um gráfico de pizza?`)
};

const pt_donut_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que difere um gráfico de rosca de um gráfico circular?`)
};

const ja_donut_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドーナツグラフは円グラフとどう違いますか？`)
};

const zh_donut_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`环形图与饼图有什么不同？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_faq_q1", locale)
	if (locale === "en") return en_donut_faq_q1(inputs)
	if (locale === "es") return es_donut_faq_q1(inputs)
	if (locale === "de") return de_donut_faq_q1(inputs)
	if (locale === "nl") return nl_donut_faq_q1(inputs)
	if (locale === "fr") return fr_donut_faq_q1(inputs)
	if (locale === "it") return it_donut_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_donut_faq_q1(inputs)
	if (locale === "pt") return pt_donut_faq_q1(inputs)
	if (locale === "ja") return ja_donut_faq_q1(inputs)
	return zh_donut_faq_q1(inputs)
};